import React from "react";
import { Row, Col, Form, Button, Alert, Modal, Spinner } from "react-bootstrap";
import mobile from "../../../componets/json/mobile.json";
import countries from "../../../componets/json/countries.json";
import apiEndPoints from "../../../componets/json/apiEndPoints.json";
import BrtxCustom from "../../../componets/BrtxCustom";
import BrtxSelect from "../../../componets/BrtxSelect";

class AddAddress extends React.Component {
  state = {
    newInvAddrContent: {
      type: this.props.addresstype,
      ico: "",
      zipcode: "",
      city: null,
      street: null,
      region: null,
      houseno: null,
      CntctName: "",
      desc: "",
      country: null,
      default: false,
    },
    incorrect: true,
    loading: {
      text: <small>Nejprve vyberte zemi</small>,
      status: false,
      variant: "warning",
    },
    regions: [],
    getRegion: 0,
    municipaties: [],
    streets: [],
    places: [],
  };

  reset() {
    this.setState({
      newInvAddrContent: {
        type: this.props.addresstype,
        ico: "",
        zipcode: "",
        city: null,
        street: null,
        region: null,
        houseno: null,
        CntctName: "",
        desc: "",
        country: null,
        default: false,
      },
      incorrect: true,
      loading: {
        text: <small>Nejprve vyberte zemi.</small>,
        status: false,
        variant: "warning",
      },
      regions: [],
      getRegion: 0,
      municipaties: [],
      streets: [],
      places: [],
    });
  }

  getRegion = async () => {
    this.setState({
      getRegion: 1,
      loading: {
        ...this.state.loading,
        text: <small>Probíhá komunikace s RUIAN</small>,
        status: true,
        variant: "info",
      },
    });
    if (this.state.regions.length == 0 && this.state.getRegion == 0) {
      const _res = await this.props._api({
        ...this.props,
        method: "get",
        endpoint: apiEndPoints.britex.ruian.regions,
        param: "",
      });
      if (_res.status == 200) {
        this.setState({
          regions: JSON.parse(
            JSON.stringify(_res.data)
              .replaceAll("regionId", "value")
              .replaceAll("regionName", "label")
          ).data,
          loading: {
            ...this.state.loading,
            text: <small>Dohledány regiony</small>,
            status: false,
            variant: "success",
          },
        });
      }
    }
  };

  getMunicipaties = async (e) => {
    this.setState({
      loading: {
        ...this.state.loading,
        text: <small>Probíhá komunikace s RUIAN</small>,
        status: true,
        variant: "info",
      },
    });
    const _res = await this.props._api({
      ...this.props,
      method: "get",
      endpoint: apiEndPoints.britex.ruian.municipaties.replace(
        "{region}",
        e.value
      ),
      param: "",
    });
    if (_res.status == 200) {
      this.setState({
        municipaties: JSON.parse(
          JSON.stringify(_res.data)
            .replaceAll("municipalityId", "value")
            .replaceAll("municipalityName", "label")
        ).data,
        newInvAddrContent: { ...this.state.newInvAddrContent, region: e },
        loading: {
          ...this.state.loading,
          text: <small>Dohledány města</small>,
          status: false,
          variant: "success",
        },
      });
    }
  };

  getStreet = async (e) => {
    this.setState({
      loading: {
        ...this.state.loading,
        text: <small>Probíhá komunikace s RUIAN</small>,
        status: true,
        variant: "info",
      },
    });
    const _res = await this.props._api({
      ...this.props,
      method: "get",
      endpoint: apiEndPoints.britex.ruian.streets.replace(
        "{municipalityId}",
        e.value
      ),
      param: "",
    });
    if (_res.status == 200) {
      let streets = [];
      _res.data.data.forEach((x) => {
        let streetsingle = {
          value: x.streetName,
          label: x.streetName,
        };
        streets.push(streetsingle);
      });
      this.setState({
        streets: streets,
        newInvAddrContent: { ...this.state.newInvAddrContent, city: e },
        loading: {
          ...this.state.loading,
          text: <small>Dohledány ulice</small>,
          status: false,
          variant: "success",
        },
      });
    }
  };

  getPlaces = async (e) => {
    this.setState({
      loading: {
        ...this.state.loading,
        text: <small>Probíhá komunikace s RUIAN</small>,
        status: true,
        variant: "info",
      },
    });
    const _res = await this.props._api({
      ...this.props,
      method: "get",
      endpoint: apiEndPoints.britex.ruian.places
        .replace("{municipalityId}", this.state.newInvAddrContent.city.value)
        .replace("{streetName}", e.value),
      param: "",
    });
    if (_res.status == 200) {
      let places = [];
      _res.data.data.forEach((x) => {
        let _custLabel = x.placeCp;
        if (x.placeCo) _custLabel += "/" + x.placeCo;
        if (x.placeCe) _custLabel += "/" + x.placeCe;
        let placesingle = {
          value: x.placeId,
          label: _custLabel,
          zip: x.placeZip,
        };
        places.push(placesingle);
      });
      this.setState({
        places: places,
        newInvAddrContent: { ...this.state.newInvAddrContent, street: e },
        loading: {
          ...this.state.loading,
          text: <small>Dohledány budovy</small>,
          status: false,
          variant: "success",
        },
      });
    }
  };

  setAddr = (e) => {
    this.setState({
      newInvAddrContent: {
        ...this.state.newInvAddrContent,
        houseno: e,
        zipcode: e.zip,
      },
    });
  };

  validateAddress = async (newInvAddrContent) => {
    this.setState({
      loading: {
        ...this.state.loading,
        text: <small>Probíhá komunikace s RUIAN</small>,
        status: true,
        variant: "info",
      },
    });
    const _res = await this.props._api({
      ...this.props,
      method: "get",
      endpoint: apiEndPoints.britex.ruian.validate
        .replace("{municipalityName}", newInvAddrContent.city)
        .replace("{zip}", newInvAddrContent.zipcode)
        .replace("{cp}", newInvAddrContent.houseno)
        .replace("{streetName}", newInvAddrContent.street),
      param: "",
    });
    if (_res.status == 200) {
      this.setState({
        newInvAddrContent: {
          ...this.state.newInvAddrContent,
          region: {
            label: _res.data.place.regionName,
            value: _res.data.place.regionName,
          },
          city: {
            label: newInvAddrContent.city,
            value: newInvAddrContent.city,
          },
          zipcode: newInvAddrContent.zipcode,
          houseno: {
            label: newInvAddrContent.houseno,
            value: newInvAddrContent.houseno,
          },
          street: {
            label: newInvAddrContent.street,
            value: newInvAddrContent.street,
          },
          CntctName: newInvAddrContent.CntctName,
        },
        loading: {
          ...this.state.loading,
          text: <small>Validace adresy proběhla úspěšně</small>,
          status: false,
          variant: "success",
        },
      });
    }
  };

  save = async () => {
    let _data = this.state.newInvAddrContent;
    if (
      !_data.mobil &&
      !_data.email &&
      (_data.type == "P" || _data.type == "D")
    ) {
      this.setState({
        loading: {
          ...this.state.loading,
          text: (
            <small>
              Pro svozovou/dodací adresu musí být zadán email nebo mobil.
            </small>
          ),
          status: false,
          variant: "danger",
        },
      });
      return;
    }
    this.props.onHide();
    this.reset();
    this.props.change(_data);
  };

  mfcr = async (e) => {
    if (e.length < 8) return;
    if (isNaN(e)) return;

    this.setState({
      loading: {
        ...this.state.loading,
        text: <small>Probíhá komunikace s veřejným rejstříkem MFCR</small>,
        status: true,
        variant: "info",
      },
    });
    const _res = await this.props._api({
      ...this.props,
      method: "get",
      endpoint: apiEndPoints.britex.mfcr.replace("{ico}", e),
      param: "",
    });
    if (_res.status == 200) {
      if (_res.data.Ares_odpovedi.Odpoved.Pocet_zaznamu == "0") {
        this.setState({
          loading: {
            ...this.state.loading,
            text: <small>Adresa nebyla nalezena.</small>,
            status: false,
            variant: "danger",
          },
        });
      } else {
        let newInvAddrContent = this.state.newInvAddrContent;
        newInvAddrContent = {
          street:
            _res.data.Ares_odpovedi.Odpoved.Zaznam.Identifikace.Adresa_ARES
              .Nazev_ulice,
          city:
            _res.data.Ares_odpovedi.Odpoved.Zaznam.Identifikace.Adresa_ARES
              .Nazev_obce,
          zipcode:
            _res.data.Ares_odpovedi.Odpoved.Zaznam.Identifikace.Adresa_ARES.PSC,
          houseno:
            _res.data.Ares_odpovedi.Odpoved.Zaznam.Identifikace.Adresa_ARES
              .Cislo_domovni,
          CntctName: _res.data.Ares_odpovedi.Odpoved.Zaznam.Obchodni_firma,
          country: countries.filter(
            (c) =>
              c.countrynum ==
              _res.data.Ares_odpovedi.Odpoved.Zaznam.Identifikace.Adresa_ARES
                .Kod_statu
          ),
        };
        this.validateAddress(newInvAddrContent);
        this.setState({
          loading: {
            ...this.state.loading,
            text: (
              <>
                <small>Byla dohledána adresa dle zadaného IČ.</small>
                <Button
                  onClick={() => this.reset()}
                  variant="transparent"
                  size="sm"
                >
                  Smazat
                </Button>
              </>
            ),
            status: false,
            variant: "success",
          },
        });
      }
    } else {
      this.setState({
        loading: {
          ...this.state.loading,
          text: <small>Adresa nebyla nalezena.</small>,
          status: false,
          variant: "danger",
        },
      });
    }
  };

  render() {
    const { Bs, VARIANT, SIZE, _icon } = this.props;
    return (
      <Modal
        show={this.props.open}
        onHide={() => this.props.onHide()}
        centered
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <span className="h5">Přidat adresu</span>
          </Modal.Title>
        </Modal.Header>
        <Alert variant={this.state.loading.variant}>
          <Row>
            <Col className="d-flex justify-content-between">
              {this.state.loading.text}
              {this.state.loading.status && (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              )}
            </Col>
          </Row>
        </Alert>
        <Modal.Body>
          <Row className="mb-2">
            <Col xs={12} md={6}>
              <BrtxSelect
                options={countries}
                onChange={(e) => {
                  if (e.value === "CZ") this.getRegion();
                  this.setState({
                    newInvAddrContent: {
                      ...this.state.newInvAddrContent,
                      country: e,
                    },
                    loading: {
                      ...this.state.loading,
                      text:
                        e.value == "CZ" ? (
                          <small>
                            V případě, že přidáváte fakturační adresu subjektu
                            nebo jste OSVČ stačí zadat IČO. Ostatní údaje se
                            doplní z veřejného rejstříku MFCR.
                          </small>
                        ) : (
                          <small>Vyplňte níže uvedené pole.</small>
                        ),
                    },
                  });
                }}
                placeholder="Vyber"
                value={this.state.newInvAddrContent.country}
              />
              <Form.Text>Region</Form.Text>
            </Col>
          </Row>
          {this.state.newInvAddrContent.country?.value == "CZ" && (
            <>
              <Row className="mb-2">
                <Col xs={12} md={6}>
                  <Form.Control
                    type="text"
                    value={this.state.newInvAddrContent.desc}
                    onChange={(e) => {
                      this.setState({
                        newInvAddrContent: {
                          ...this.state.newInvAddrContent,
                          desc: e.target.value,
                        },
                      });
                    }}
                  />
                  <Form.Text>
                    Název adresy{" "}
                    <small className="text-muted">(Volitelný popis)</small>
                  </Form.Text>
                </Col>
                <Col xs={12} md={6}>
                  <Bs inputgroup>
                    <BrtxCustom
                      mask="99999999"
                      onChange={(e) => {
                        this.setState({
                          newInvAddrContent: {
                            ...this.state.newInvAddrContent,
                            ico: e.target.value,
                          },
                        });
                      }}
                      value={this.state.newInvAddrContent.ico}
                    />
                    <Bs
                      button
                      variant={VARIANT.SUCCESS}
                      size={SIZE.SM}
                      data-tip="Načíst z MFCR sídlo"
                      onClick={() =>
                        this.mfcr(this.state.newInvAddrContent.ico)
                      }
                    >
                      <_icon fasearch />
                    </Bs>
                  </Bs>

                  <Form.Text>IČO</Form.Text>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs={12} md={6}>
                  <Form.Control
                    type="text"
                    value={this.state.newInvAddrContent.CntctName}
                    onChange={(e) => {
                      this.setState({
                        newInvAddrContent: {
                          ...this.state.newInvAddrContent,
                          CntctName: e.target.value,
                        },
                      });
                    }}
                  />
                  <Form.Text>Název subjektu / Kontaktní osoba</Form.Text>
                </Col>

                <Col xs={12} md={6}>
                  <BrtxSelect
                    options={this.state.regions}
                    isDisabled={!this.state.newInvAddrContent.CntctName}
                    onChange={(e) => this.getMunicipaties(e)}
                    placeholder="Vyber kraj"
                    value={this.state.newInvAddrContent.region}
                  />
                  <Form.Text>Kraj</Form.Text>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs={12} md={3}>
                  <BrtxSelect
                    options={this.state.municipaties}
                    isDisabled={!this.state.newInvAddrContent.region}
                    onChange={(e) => this.getStreet(e)}
                    placeholder="Vyber město"
                    value={this.state.newInvAddrContent.city}
                  />
                  <Form.Text>Město</Form.Text>
                </Col>
                <Col xs={12} md={4}>
                  <BrtxSelect
                    options={this.state.streets}
                    isDisabled={!this.state.newInvAddrContent.city}
                    onChange={(e) => this.getPlaces(e)}
                    placeholder="Vyber ulici"
                    value={this.state.newInvAddrContent.street}
                  />
                  <Form.Text>Ulice</Form.Text>
                </Col>
                <Col xs={12} md={2}>
                  <BrtxSelect
                    options={this.state.places}
                    isDisabled={!this.state.newInvAddrContent.street}
                    onChange={(e) => this.setAddr(e)}
                    placeholder="Č.P."
                    value={this.state.newInvAddrContent.houseno}
                  />
                  <Form.Text>Č.P.</Form.Text>
                </Col>
                <Col xs={12} md={3}>
                  <BrtxCustom
                    mask="999 99"
                    disabled={"true"}
                    value={this.state.newInvAddrContent.zipcode}
                    onChange={(e) =>
                      this.setState({
                        newInvAddrContent: {
                          ...this.state.newInvAddrContent,
                          zipcode: e.target.value,
                        },
                      })
                    }
                  />
                  <Form.Text>PSČ</Form.Text>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs={12} md={5}>
                  <Form.Control
                    type="email"
                    value={this.state.newInvAddrContent.email}
                    onChange={(e) =>
                      this.setState({
                        newInvAddrContent: {
                          ...this.state.newInvAddrContent,
                          email: e.target.value,
                        },
                      })
                    }
                  />
                  <Form.Text>email</Form.Text>
                </Col>
                <Col xs={12} md={2}>
                  <BrtxSelect
                    options={mobile}
                    placeholder="+420"
                    value={this.state.newInvAddrContent.pre_mobile}
                  />
                  <Form.Text>Předvolba</Form.Text>
                </Col>
                <Col xs={12} md={5}>
                  <BrtxCustom
                    mask="999 999 999"
                    value={this.state.newInvAddrContent.mobil}
                    onChange={(e) =>
                      this.setState({
                        newInvAddrContent: {
                          ...this.state.newInvAddrContent,
                          mobil: e.target.value,
                        },
                      })
                    }
                  />
                  <Form.Text>mobil</Form.Text>
                </Col>
              </Row>
            </>
          )}
          {this.state.newInvAddrContent.country?.value != "CZ" &&
            this.state.newInvAddrContent.country && (
              <>
                <Row className="mb-2">
                  <Col xs={12} md={6}>
                    <Form.Control
                      type="text"
                      value={this.state.newInvAddrContent.desc}
                      onChange={(e) => {
                        this.setState({
                          newInvAddrContent: {
                            ...this.state.newInvAddrContent,
                            desc: e.target.value,
                          },
                        });
                      }}
                    />
                    <Form.Text>
                      Název adresy{" "}
                      <small className="text-muted">(Volitelný popis)</small>
                    </Form.Text>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Control
                      type="text"
                      disabled={!this.state.newInvAddrContent.desc}
                      onChange={(e) => {
                        this.setState({
                          newInvAddrContent: {
                            ...this.state.newInvAddrContent,
                            ico: e.target.value,
                          },
                        });
                      }}
                      value={this.state.newInvAddrContent.ico}
                    />
                    <Form.Text>IČO</Form.Text>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={12} md={6}>
                    <Form.Control
                      disabled={!this.state.newInvAddrContent.desc}
                      type="text"
                      value={this.state.newInvAddrContent.CntctName}
                      onChange={(e) => {
                        this.setState({
                          newInvAddrContent: {
                            ...this.state.newInvAddrContent,
                            CntctName: e.target.value,
                          },
                        });
                      }}
                    />
                    <Form.Text>Název subjektu / Kontaktní osoba</Form.Text>
                  </Col>

                  <Col xs={12} md={6}>
                    <Form.Control
                      disabled={!this.state.newInvAddrContent.CntctName}
                      onChange={(e) =>
                        this.setState({
                          newInvAddrContent: {
                            ...this.state.newInvAddrContent,
                            region: e.target.value,
                          },
                        })
                      }
                      value={this.state.newInvAddrContent.region}
                    />
                    <Form.Text>Kraj</Form.Text>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={12} md={3}>
                    <Form.Control
                      disabled={!this.state.newInvAddrContent.region}
                      onChange={(e) =>
                        this.setState({
                          newInvAddrContent: {
                            ...this.state.newInvAddrContent,
                            city: e.target.value,
                          },
                        })
                      }
                      value={this.state.newInvAddrContent.city}
                    />
                    <Form.Text>Město</Form.Text>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Control
                      disabled={!this.state.newInvAddrContent.city}
                      onChange={(e) =>
                        this.setState({
                          newInvAddrContent: {
                            ...this.state.newInvAddrContent,
                            street: e.target.value,
                          },
                        })
                      }
                      value={this.state.newInvAddrContent.street}
                    />
                    <Form.Text>Ulice</Form.Text>
                  </Col>
                  <Col xs={12} md={2}>
                    <Form.Control
                      disabled={!this.state.newInvAddrContent.street}
                      onChange={(e) =>
                        this.setState({
                          newInvAddrContent: {
                            ...this.state.newInvAddrContent,
                            houseno: e.target.value,
                          },
                        })
                      }
                      value={this.state.newInvAddrContent.houseno}
                    />
                    <Form.Text>Č.P.</Form.Text>
                  </Col>
                  <Col xs={12} md={3}>
                    <Form.Control
                      disabled={!this.state.newInvAddrContent.houseno}
                      value={this.state.newInvAddrContent.zipcode}
                      onChange={(e) =>
                        this.setState({
                          newInvAddrContent: {
                            ...this.state.newInvAddrContent,
                            zipcode: e.target.value,
                          },
                        })
                      }
                    />
                    <Form.Text>PSČ</Form.Text>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={12} md={5}>
                    <Form.Control
                      type="email"
                      value={this.state.newInvAddrContent.email}
                      onChange={(e) =>
                        this.setState({
                          newInvAddrContent: {
                            ...this.state.newInvAddrContent,
                            email: e.target.value,
                          },
                        })
                      }
                    />
                    <Form.Text>email</Form.Text>
                  </Col>
                  <Col xs={12} md={2}>
                    <BrtxSelect
                      options={mobile}
                      placeholder="+420"
                      value={this.state.newInvAddrContent.pre_mobile}
                    />
                    <Form.Text>Předvolba</Form.Text>
                  </Col>
                  <Col xs={12} md={5}>
                    <BrtxCustom
                      mask="999 999 999"
                      value={this.state.newInvAddrContent.mobil}
                      onChange={(e) =>
                        this.setState({
                          newInvAddrContent: {
                            ...this.state.newInvAddrContent,
                            mobil: e.target.value,
                          },
                        })
                      }
                    />
                    <Form.Text>mobil</Form.Text>
                  </Col>
                </Row>
              </>
            )}
          <Row>
            <Col xs={12} className="d-flex justify-content-end">
              <Button
                variant="success"
                size="sm"
                disabled={!this.state.newInvAddrContent.zipcode}
                onClick={() => this.save()}
              >
                Přidat
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}

export default AddAddress;
